"use client";
import { useState, useEffect } from "react";
import NavbarLogo from "./NavbarLogo";
import NavbarLinks from "./NavbarLinks";
import NavbarCTA from "./NavbarCTA";
import NavbarMobile from "./NavbarMobile";

const Navbar = ({
  isNotificationBarVisible,
}: {
  isNotificationBarVisible: boolean;
}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const topPosition = isScrolled
    ? "top-0"
    : isNotificationBarVisible
    ? "top-14"
    : "top-5";

  return (
    <>
      {/* Desktop Navbar */}
      <div
        className={`hidden lg:flex w-full justify-center fixed z-50 transition-all duration-300 ${topPosition}`}
      >
        <div className="flex flex-row items-center justify-between gap-4 rounded-xl border border-neutral-200/50 bg-[#F2F1F0]/80 py-2 px-3 shadow-lg backdrop-blur-[25px]">
          <div className="flex lg:justify-between justify-center items-center">
            <NavbarLogo />
          </div>

          <div className="flex flex-row gap-2 items-center">
            <NavbarLinks />
            <NavbarCTA />
          </div>
        </div>
      </div>

      {/* Mobile Navbar */}
      <NavbarMobile />
    </>
  );
};

export default Navbar;
